import { Exchange, ExchangeId } from '@robotrader/common-types';
import { DataError, Either } from '@robotrader/core-lib';

import { AppConfig } from '@/core/config';
import { HTTPService } from '@/modules/shared';
import {
  EditExchangeParameters,
  ExchangeRepository,
} from '@/modules/trader/domain';

import { ExchangeMapper } from './ExchangeMapper';
import { GetExchangeResponse } from './GetExchangeResponse';
import { GetExchangesResponse } from './GetExchangesResponse';

interface ExchangeHTTPRepositoryProps {
  httpService: HTTPService;
  config: AppConfig;
}

export class ExchangeHTTPRepository implements ExchangeRepository {
  private http: HTTPService;
  private config: AppConfig;

  constructor({ httpService, config }: ExchangeHTTPRepositoryProps) {
    this.http = httpService;
    this.config = config;
  }

  async getAll(): Promise<Either<DataError, Exchange[]>> {
    try {
      const {
        data: { data: exchangesDto },
      } = await this.http.get<GetExchangesResponse>(
        `${this.config.apiUrl}/exchanges`,
      );

      return Either.right(
        ExchangeMapper.exchangeDtoArrayToExchangeArray(
          exchangesDto.sort((e1, e2) => e1.id - e2.id),
        ),
      );
    } catch (error) {
      return Either.left({ kind: 'UnexpectedError', message: error as Error });
    }
  }

  async editExchange(
    exchangeId: ExchangeId,
    props: EditExchangeParameters,
  ): Promise<Either<DataError, Exchange>> {
    try {
      const {
        data: { data: exchangeDto },
      } = await this.http.put<GetExchangeResponse>(
        `${this.config.apiUrl}/admin/exchange/${exchangeId}`,
        props,
      );

      return Either.right(ExchangeMapper.exchangeDtoToExchange(exchangeDto));
    } catch (error) {
      return Either.left({ kind: 'UnexpectedError', message: error as Error });
    }
  }
}
